import { render, staticRenderFns } from "./CapitalModel.vue?vue&type=template&id=a604e9b2&scoped=true"
import script from "./CapitalModel.vue?vue&type=script&lang=js"
export * from "./CapitalModel.vue?vue&type=script&lang=js"
import style0 from "./CapitalModel.vue?vue&type=style&index=0&id=a604e9b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a604e9b2",
  null
  
)

export default component.exports